var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.374,
    height: 11.596,
    viewBox: "0 0 12.374 11.596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.374,22.5v2.416a1.208,1.208,0,0,1-1.208,1.208H5.708A1.208,1.208,0,0,1,4.5,24.916V22.5",
    transform: "translate(-4.5 -16.029)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.5,15l3.021,3.021L16.541,15",
    transform: "translate(-8.084 -11.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18,11.749V4.5",
    transform: "translate(-12.563 -4.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b93fbcaa052453a44f2454518e1efbb4.svg";
export { ForwardRef as ReactComponent };